import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-shared-header-div',
  templateUrl: './shared-header-div.component.html'
})
export class SharedHeaderDivComponent implements OnInit {

  @Input() screentitle: string;
  @Input() Errmessage: string;
  @Input() headerDivName: string;
  @Input() actionmode: string;
  @Output() private submitDataOne = new EventEmitter<any>();
  @Output() private search_Form = new EventEmitter<any>();

  constructor() { }

  ngOnInit(): void {
  }

  submitData() {
    this.submitDataOne.emit(true)
  }

  searchForm() {
    this.search_Form.emit(true);
  }

}
